import {GridModel} from './gridModel'

export const initialState: GridModel = {
  healthGrid: {
    totalRow: undefined,
    data: undefined,
  },
  customerGrid: {
    totalRow: undefined,
    data: undefined,
  },
  autoGrid: {
    totalRow: undefined,
    data: undefined,
  },
  motoGrid: {
    totalRow: undefined,
    data: undefined,
  },
  houseGrid: {
    totalRow: undefined,
    data: undefined,
  },
  paymentGrid: {
    totalRow: undefined,
    data: undefined,
  },
  certificateGrid: {
    totalRow: undefined,
    data: undefined,
  },
  certificateManageGrid: {
    totalRow: undefined,
    data: undefined,
  },
  commissionGrid: {
    totalRow: undefined,
    data: undefined,
  },
  renewGrid: {
    totalRow: undefined,
    data: undefined,
  },
  checkMoneyGrid: {
    totalRow: undefined,
    data: undefined,
  },
  paymentSalaryGrid: {
    totalRow: undefined,
    data: undefined,
  },
  cargoGrid: {
    totalRow: undefined,
    data: undefined,
  },
  marineGrid: {
    totalRow: undefined,
    data: undefined,
  },
  propertyGrid: {
    totalRow: undefined,
    data: undefined,
  },
  technicalGrid: {
    totalRow: undefined,
    data: undefined,
  },
  microGrid: {
    totalRow: undefined,
    data: undefined,
  }
}
